<template>
  <div
    class="col-span-4 lg:col-span-3 place-self-center justify-self-start"
  >
    <!-- Modifier/Visualiser fiche -->
    <action-button
      v-if="canEdit && !usedInEval"
      border-color="border-transparent"
      text-color="text-gray-900"
      bg-color="bg-indigo-300"
      bg-color-square="bg-white"
      icon-color="text-indigo-600"
      icon="edit"
      :responsive="true"
      :libelle="`Modifier ${
        type === 'job_desc' ? 'la fiche' : 'le référentiel'
      }`"
      @clickAction="$emit('edit')"
    />
    <action-button
      v-else-if="canView && usedInEval"
      border-color="border-transparent"
      text-color="text-gray-900"
      bg-color="bg-indigo-300"
      bg-color-square="bg-white"
      icon-color="text-indigo-600"
      icon="edit"
      :responsive="true"
      :libelle="`Visualiser ${
        type === 'job_desc' ? 'la fiche' : 'le référentiel'
      }`"
      @clickAction="$emit('show')"
    />
    <div
      v-else-if="personalLibrary && (usedInEval || !canEdit)"
      @mouseenter="evalInProgressTooltip = true"
      @mouseleave="evalInProgressTooltip = false"
    >
      <div class="flex flex-col relative">
        <div class="h-0">
          <transition
            enter-active-class="duration-300"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-show="evalInProgressTooltip"
              v-html="
                canEdit
                  ? 'Vous ne pouvez pas modifier ' +
                    (type === 'job_desc'
                      ? 'cette fiche de poste'
                      : 'ce référentiel de formation') +
                    ' car il y a une évaluation en cours.'
                  : 'Vous n\'êtes pas autorisé à modifier ' +
                    (type === 'job_desc'
                      ? 'cette fiche de poste'
                      : 'ce référentiel de formation')
              "
              class="tooltip-Label bg-indigo-600 text-white flex absolute rounded-lg shadow-lg text-xs z-50 py-3 px-4 bottom-3 right-0 w-max-content w-max max-w-64 md:max-w-72 xl:max-w-80"
            />
          </transition>
        </div>
      </div>
      <action-button
        class="cursor-not-allowed"
        border-color="border-transparent"
        text-color="text-gray-600"
        bg-color="bg-gray-300"
        bg-color-square="bg-white"
        icon-color="text-gray-600"
        icon="edit"
        :responsive="true"
        :libelle="
          'Modifier ' +
            (type === 'job_desc' ? 'la fiche' : 'le référentiel')
        "
      />
    </div>
    <action-button
      v-else-if="!personalLibrary && canImport && !disabled"
      border-color="border-transparent"
      text-color="text-gray-900"
      bg-color="bg-indigo-300"
      bg-color-square="bg-white"
      icon-color="text-indigo-600"
      icon="plus"
      :responsive="true"
      libelle="Ajouter à ma bibliothèque"
      @clickAction="$emit('import')"
    />
    <action-button
      v-else-if="!personalLibrary && canImport && disabled"
      class="cursor-not-allowed"
      border-color="border-transparent"
      text-color="text-gray-600"
      bg-color="bg-gray-300"
      bg-color-square="bg-white"
      icon-color="text-gray-600"
      icon="plus"
      :responsive="true"
      libelle="Ajouter à ma bibliothèque"
    />
    <div
      v-else-if="!personalLibrary && !canImport"
      @mouseenter="notEnoughRightsTooltip = true"
      @mouseleave="notEnoughRightsTooltip = false"
    >
      <div class="flex flex-col relative">
        <div class="h-0">
          <transition
            enter-active-class="duration-300"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-show="notEnoughRightsTooltip"
              v-html="
                'Vous n\'êtes pas autorisé à ajouter ' +
                  (type === 'job_desc'
                    ? 'une fiche de poste'
                    : 'un référentiel de formation') +
                  ' dans la bibliothèque personnelle'
              "
              class="tooltip-Label bg-indigo-600 text-white flex absolute rounded-lg shadow-lg text-xs z-50 py-3 px-4 bottom-3 right-0 w-max-content w-max max-w-64 md:max-w-72 xl:max-w-80"
            />
          </transition>
        </div>
      </div>
      <action-button
        class="cursor-not-allowed"
        border-color="border-transparent"
        text-color="text-gray-600"
        bg-color="bg-gray-300"
        bg-color-square="bg-white"
        icon-color="text-gray-600"
        icon="plus"
        :responsive="true"
        libelle="Ajouter à ma bibliothèque"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from '../components/ActionButton.vue';

export default {
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    personalLibrary: {
      type: Boolean,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    canView: {
      type: Boolean,
      required: true
    },
    canImport: {
      type: Boolean,
      required: true
    },
    usedInEval: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  components: {
    ActionButton
  },

  data() {
    return {
      evalInProgressTooltip: false,
      notEnoughRightsTooltip: false
    };
  }
};
</script>